import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
  projectId: '658pmwv6',
  dataset: 'production',
  apiVersion: '2022-02-01',
  useCdn: true,
  token: 'skQC7wXpYYE2VOXD9ROoIgqanMCzZbLwjJHscAojBoCeOyIHNAOYr9CjvG8Yy3X8dmQTIaUkoeB6SybxDXecpxwkvbeyEiceTAakvuC39TTZff6Vip5FBfwsFsvS9zgBAJZU0QaVXhPCg9r1mZPcavEpH5yPmJkiA5j3G3bSVLThVYd568l8',
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);
